/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

@file:Suppress("unused")

package net.sergeych.utools

import kotlin.time.Clock
import kotlin.time.Instant

fun now(): Instant = Clock.System.now()
fun nowToSeconds(): Instant = Clock.System.now().truncateToSeconds()

fun Instant.truncateToSeconds(): Instant =
    Instant.fromEpochSeconds(toEpochMilliseconds()/1000)